import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100vh;
`

export const NavBar = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
`

export const NavIcon = styled.div`
  display: flex;
`

export const CloseButton = styled.div`
  position: absolute;
  left: ${Spacing.Medium}px;
  top: ${Spacing.Medium}px;
`
